import {InjectionToken} from '@angular/core';

/**
 * Minimal shape of the HTTP response object available during SSR.
 * Provided by the Express server (see server.ts); absent in the browser.
 */
export interface ServerResponseRef {
  status(code: number): unknown;
  /** Express res.setHeader — optional so tiny test doubles with only status() still fit. */
  setHeader?(name: string, value: string): unknown;
}

export const SERVER_RESPONSE = new InjectionToken<ServerResponseRef>('SERVER_RESPONSE');
